import { cn } from '@/lib/utils.ts';

interface StepperProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

export function ProgressBarStepper({ currentStep, totalSteps, className }: StepperProps) {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div
      className={cn('h-3 w-full overflow-hidden rounded-t-md bg-hydrangea-100', className)}
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={`Step ${currentStep} of ${totalSteps}`}
    >
      <div
        className="h-full bg-hydrangea-500 transition-all duration-300 ease-in-out"
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
}
